import { backgroundColorWhite } from './palette';

export const hintPopupBgColor = backgroundColorWhite;
